import axios from "axios";

const api = axios.create({
    baseURL: process.env.REACT_APP_URL,
    headers: {
        'Accept' : 'application/json'
    }
});

api.interceptors.request.use(function(config) {
    const token = localStorage.getItem('@App:token')
    config.headers = {
        ...config.headers,
        'Accept' : 'application/json',
        ...(token ? { 'Authorization': `Bearer ${token}` } : {})
    }
    return config;
});

api.interceptors.response.use(function(response) {
    return response;
}, function(error) {
    if(error.response && (error.response.status === 401 || error.response.data?.message === 'Unauthenticated')) {
        localStorage.removeItem('@App:token');
        window.location.replace('/login');
    }
    return Promise.reject(error);
});

export default api
